<app-header></app-header>

<!-- Sección con fondo de imagen y texto de bienvenida -->
<div class="bg-image-container">
  <div class="container" style="max-width: 1200px;">
    <h2 class="text-white text-center py-5">Bienvenido(a) al portal del manual de pagos de servicios
    </h2>
  </div>
</div>

<!-- Sección con texto y botones para redirigir -->
<div class="container" style="max-width: 1200px;">
  <!-- Texto de la sección -->
  <p class="text-center mt-5" style="font-size: 1.2rem;">
    <strong>
      Actualmente, puedes realizar tus
      <span style="color: #B72727;">pagos de servicios</span> en cualquiera de los siguientes bancos:
    </strong>
  </p>


  <!-- Contenedor de los botones con imágenes -->
  <div class="row justify-content-center mt-10">
    <!-- Botón para BCP -->
    <div class="col-12 col-lg-4 d-flex justify-content-center mb-4">
      <a href="/bcp" class="btn-bank">
        <div class="button-box">
          <img src="assets/bcp-logo.png" style="width: 150px;" alt="Logo BCP" class="img-fluid rounded">
        </div>
      </a>
    </div>

    <!-- Botón para Interbank -->
    <div class="col-12 col-lg-4 d-flex justify-content-center mb-4">

      <a href="/interbank" class="btn-bank">
        <div class="button-box">
          <img src="assets/interbank-logo.png" alt="Logo Interbank" class="img-fluid rounded">
        </div>
      </a>
    </div>

    <!-- Pagalo-pe-->
    <div class="col-12 col-lg-4 d-flex justify-content-center mb-4">
      <a href="/pagalo-pe" class="btn-bank">
        <div class="button-box">
          <img src="assets/logo-pagalo-pe.png" style="width: 180px;" alt="Logo Págalo.pe" class="img-fluid rounded">
        </div>
      </a>
    </div>
  </div>
</div>

<!-- Sección con figura rectangular con borde rojo -->
<div class="container mt-5" style="max-width: 1200px;">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-6">
      <!-- Contenedor del rectángulo -->
      <div class="rectangle-box p-4 d-flex align-items-center">
        <!-- Imagen roja en la izquierda -->
        <div class="image-container me-4">
          <img src="assets/info-pregunta.png" alt="Pregunta" class="img-fluid red-icon">
        </div>
        <!-- Texto en la parte derecha -->
        <div>
          <p class="font-weight-bold mb-2">¿Cómo realizar el pago?</p>
          <p style="font-size: 1rem;">Para conocer las indicaciones detalladas de pago, haz clic en el ícono de tu banco
            de preferencia.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
